<template>
  <div class="empty_list">
    <img src="../../assets/images/search/icon-error-74.png" alt=""/>
    <p>해당데이터가 없습니다.</p>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  .empty_list {
    position: relative;
    width: 100%;
    height: 400px;
    margin-top: 200px;
    text-align: center;
  }

  .empty_list > p{
    margin-top: 12px;
    font-size: 18px;
    line-height: 1;
    color: #a5a5a5;
  }

  .empty_list img{
    width: 74px;
  }
</style>
